import { FaSyringe, FaUserMd, FaPrescriptionBottleAlt, FaRegQuestionCircle, FaUserInjured, FaSpinner } from "react-icons/fa";
import { IconType } from "react-icons/lib";
import { CSSProperties } from "styled-components";

// Source: https://react-icons.github.io/react-icons/

type IconsType = {
  [key: string]: IconType;
}

const Icons: IconsType = {
  "Syringe": FaSyringe,
  "Doctor": FaUserMd,
  "PrescriptionBottle": FaPrescriptionBottleAlt,
  "Help": FaRegQuestionCircle,
  "Reception": FaUserInjured,
  "Spinner": FaSpinner
}

type IconProps = {
  name: string;
  size?: string | number;
  color?: string;
	style?: CSSProperties;
}

export const Icon = ({ name, size = 16, color, style }: IconProps) => {
  const Ic = Icons[name];
  if (!Ic) {
    return null;
  }

  return (
    <Ic color={color ? color : undefined} size={size} style={style} />
  )
}
